var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section-1'),_c('section-2'),_c('section-3'),_c('section-4'),_c('section-5',{attrs:{"id":"Seguros"}}),_c('section-6',{attrs:{"id":"Contactanos"}}),_c('section-7',{attrs:{"id":"FAQ"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }